import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/Logo.svg";
import settingIcon from "../../assets/images/settingIcon.svg";
import contactIcon from "../../assets/images/contactIcon.svg";
import homeIcon from "../../assets/images/homeIcon.svg";
import faqIcon from "../../assets/images/faqIcon.svg";
import downArrow from "../../assets/images/downArrow.svg";
import logout from "../../assets/images/logout.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProductListHandler } from "../../redux/action/getProductList";
import { useTranslation } from "react-i18next";
import { getNotificationCountsHandler } from "../../redux/action/getNotificationsCounts";
import { getItem, setItem } from "../../common/localStorage";
import { getProductFeaturesHandler } from "./../../redux/action/getProductFeatures";
import CommonModal from "../LogoutModal/LogoutModal";

const Sidebar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location  = useLocation()
  const [productMenu, setProductMenu] = useState(true);

  const getAllProductListSelector = useSelector(
    (state) => state?.getProductList
  );
  const getProductFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures
  );
  const getNotificationsCountsSelector = useSelector(
    (state) => state?.getNotificationsCounts
  );
  const { t } = useTranslation();
  const getAdminId = getItem("adminId");

  const activeToggle = (value) => {
    setProductMenu(false);
    navigate(value, { state: getProductFeaturesSelector });
  };

  // useEffect(() => {
  //   if (getNotificationsCountsSelector?.data?.data?.userAgreement === false) {
  //     navigate("/consent");
  //   }
  // }, [getNotificationsCountsSelector]);

  useEffect(() => {
    if (getAdminId) {
      let payload = {
        userId: getAdminId,
        refBrandId: 1,
      };
      dispatch(getProductListHandler(payload));
    }
  }, []);

  useEffect(() => {
    dispatch(getNotificationCountsHandler({ userId: getAdminId ?? 0 }));
  }, []);

  const handleCancelChange = () => {
    setIsModalOpen(false);
  };

  const handleConfirmChange = () => {
    setIsModalOpen(false);
    localStorage.clear();
    window.location.replace("/");
  };

  const getGroupId = getItem("groupId");
  const getProdcuctId = getItem("productCode");
  const handleCLick = async (item) => {
    let payload = {
      userId: getAdminId ?? 0,
      groupId: getGroupId
        ? getGroupId
        : getAllProductListSelector?.data?.data?.products?.[0].groupId,
      productCode: getProdcuctId
        ? getProdcuctId
        : getAllProductListSelector?.data?.data?.products?.[0].productCode,
    };
    dispatch(getProductFeaturesHandler(payload));
    navigate("/dashboard", { state: item });
    setItem("groupId", item?.groupId);
    setItem("productCode", item?.productCode);
    setItem("productName", item?.productName);
  };
  return (
    <>
      <div className="sidebar">
        <div>
          <div className="sidebarHeader">
            <img
              src={Logo}
              alt=""
              className="cursor-pointer"
              onClick={() => navigate("/dashboard")}
            />
          </div>
          <div className="sidebarContent">
            <div className="">
              <div
                className={`productMenu listItem ${
                  location.pathname === "/dashboard" ? "" : ""
                } ${productMenu ? "rotate active" : ""}`}
                onClick={() => setProductMenu(!productMenu)}
              >
                <img src={homeIcon} alt="" /> <span>{t("Products")}</span>
                <img src={downArrow} alt="" className="dropdownArrow" />
              </div>
              {getAllProductListSelector?.data?.data?.products?.map(
                (item, index) => {
                  return productMenu &&
                    getAllProductListSelector?.data?.data?.products?.length >
                      0 ? (
                    <div
                      key={index}
                      className={`productList cursor-pointer ${
                        getItem("productCode") === item?.productCode ||
                        (!getItem("productCode") &&
                          getAllProductListSelector?.data?.data?.products?.[0]
                            ?.productCode === item?.productCode)
                          ? "activated"
                          : ""
                      }`}
                      onClick={() => {
                        handleCLick(item);
                      }}
                    >
                      {item?.productName}
                    </div>
                  ) : null;
                }
              )}
              <div
                className={`listItem ${
                  location?.pathname === "/contact" ? "active" : ""
                }`}
                onClick={() => activeToggle("/contact")}
              >
                <img src={contactIcon} alt="" /> <span>{t("Contact")}</span>
              </div>
              <div
                className={`listItem ${
                  location?.pathname === "/FAQs" ? "active" : ""
                }`}
                onClick={() => activeToggle("/FAQs")}
              >
                <img src={faqIcon} alt="" /> <span>{t("FAQs")}</span>
              </div>
              <div
                className={`listItem ${[
                  "/settings",
                  "/profile-change",
                  "/manage-notification",
                  "/support-request"
                ].includes(location?.pathname) ? "active" : ""}`}
                onClick={() => activeToggle("/settings")}
              >
                <img src={settingIcon} alt="" /> <span>{t("Settings")}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="sidebarFooter">
          <div
            className="listItem"
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            <img src={logout} alt="" /> <span>{t("Logout")}</span>
          </div>
        </div>
      </div>
      {/* )} */}

      {/* Logout Modal */}
      {isModalOpen && (
        <CommonModal isModalOpen={isModalOpen} handleCancelChange={handleCancelChange} handleConfirmChange ={handleConfirmChange}/>
      )}
    </>
  );
};

export default Sidebar;
